module.exports = __webpack_public_path__ + "static/symptoms-cff6a2986e72e00f9ca124da1d8abc2b.png";